import * as React from "react";
import { Eye, EyeOff } from "lucide-react";

import { cn } from "~/lib/utils";

const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, ...props }, ref) => {
    const [show, setShow] = React.useState(false);
    return (
      <div className="relative">
        <input
          ref={ref}
          type={show ? "text" : "password"}
          data-slot="input"
          className={cn(
            "border-hairline bg-surface placeholder:text-text-faint h-8 w-full min-w-0 rounded-md border pl-2.5 pr-9 text-[13px] leading-none outline-none transition-colors selection:bg-primary selection:text-primary-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
            "focus-visible:border-ring focus-visible:ring-ring/40 focus-visible:ring-2 focus-visible:ring-offset-0",
            "aria-invalid:border-destructive aria-invalid:ring-destructive/30 aria-invalid:ring-2",
            className,
          )}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Hide password" : "Show password"}
          className="text-text-faint hover:text-foreground absolute inset-y-0 right-0 flex items-center pr-2.5 transition-colors"
        >
          {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
